import Delete from "@mui/icons-material/Delete";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import get from "lodash/get";
import BSInput from "../../../common/js/components/BSInput";
import "./Condo.css";

const StyledCenterCell = styled("div")({
    textAlign: "center",
    fill: "#9e9e9e",
});

const StyledShrinkButton = styled(Button)({
    padding: 0,
    minWidth: 0,
    minHeight: 0,
    margin: 0,
    color: "#9e9e9e",
    "&:hover": {
        backgroundColor: "transparent",
    },
});

const StyledResponsiveFlexItem = styled("div")({
    flex: "auto",
});

const CondoDetail = (props) => {
    const {
        dataPathPrefix,
        disableInputs,
        element,
        elementIndex,
        errors,
        handleBlurValidate,
        handleUpdateArrayElement,
        onDelete,
    } = props;

    return (
        <div>
            <div className={elementIndex === 0 ? "condoFlexContainer" : "condoFlexContainerWElementIndex"}>
                <StyledResponsiveFlexItem>
                    <BSInput
                        id="condoNumber"
                        label={elementIndex === 0 ? "Condo Number" : null}
                        placeholder="Enter condo number"
                        error={get(errors, `condos.${elementIndex}.condoNumber`, null)}
                        value={element ? element.condoNumber : null}
                        onChange={(e) =>
                            handleUpdateArrayElement(
                                dataPathPrefix + ".condos",
                                elementIndex,
                                e.target.id,
                                e.target.value
                            )
                        }
                        disabled={disableInputs}
                    />
                </StyledResponsiveFlexItem>
                <StyledResponsiveFlexItem>
                    <BSInput
                        id="condoSf"
                        label={elementIndex === 0 ? "Condo Square Feet" : null}
                        errorText="(ex. 98101)"
                        placeholder="Enter SF"
                        value={element ? element.condoSf : null}
                        error={get(errors, `condos.${elementIndex}.condoSf`, null)}
                        onChange={(e) =>
                            handleUpdateArrayElement(
                                dataPathPrefix + ".condos",
                                elementIndex,
                                e.target.id,
                                e.target.value
                            )
                        }
                        disabled={disableInputs}
                        onBlurValidate={(id, value) => handleBlurValidate("condo", id, value)}
                        integer
                    />
                </StyledResponsiveFlexItem>
                <StyledResponsiveFlexItem>
                    <BSInput
                        id="condoParcelId"
                        label={elementIndex === 0 ? "Unit Count" : null}
                        placeholder="Enter count"
                        value={element ? element.condoParcelId : null}
                        error={get(errors, `condos.${elementIndex}.condoParcelId`, null)}
                        onChange={(e) =>
                            handleUpdateArrayElement(
                                dataPathPrefix + ".condos",
                                elementIndex,
                                e.target.id,
                                e.target.value
                            )
                        }
                        disabled={disableInputs}
                    />
                </StyledResponsiveFlexItem>
                <StyledCenterCell className={`${elementIndex === 0 ? "condoParcelRightPadding" : ""}`}>
                    {elementIndex > 0 && disableInputs !== true && (
                        <StyledShrinkButton onClick={() => onDelete(elementIndex)}>
                            <Delete />
                        </StyledShrinkButton>
                    )}
                </StyledCenterCell>
            </div>
        </div>
    );
};

export default CondoDetail;
